import { DependencyList, EffectCallback, useEffect, useRef } from 'react';

function useUpdateEffect(effect: EffectCallback, dependencies: DependencyList) {
  const isInitialRender = useRef(true);

  useEffect(() => {
    // Skip the first render
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      // run the effect on updates
      return effect();
    }
  }, dependencies);
}

export default useUpdateEffect;
